// TODO: Country code selection will have to be more complex than a simple html select.
export const COUNTRY_CODES = [
  "-",
  "+1",
  "+7",
  "+20",
  "+27",
  "+30",
  "+31",
  "+32",
  "+33",
  "+34",
  "+36",
  "+39",
  "+40",
  "+41",
  "+43",
  "+44",
  "+45",
  "+46",
  "+47",
  "+48",
  "+49",
  "+51",
  "+52",
  "+53",
  "+54",
  "+55",
  "+56",
  "+57",
  "+58",
  "+60",
  "+61",
  "+62",
  "+63",
  "+64",
  "+65",
  "+66",
  "+81",
  "+82",
  "+84",
  "+86",
  "+90",
  "+91",
  "+92",
  "+93",
  "+94",
  "+95",
  "+98",
  "+211",
  "+212",
  "+213",
  "+216",
  "+218",
  "+220",
  "+221",
  "+222",
  "+223",
  "+224",
  "+225",
  "+226",
  "+227",
  "+228",
  "+229",
  "+230",
  "+231",
  "+232",
  "+233",
  "+234",
  "+235",
  "+236",
  "+237",
  "+238",
  "+239",
  "+240",
  "+241",
  "+242",
  "+243",
  "+244",
  "+245",
  "+246",
  "+248",
  "+249",
  "+250",
  "+251",
  "+252",
  "+253",
  "+254",
  "+255",
  "+256",
  "+257",
  "+258",
  "+260",
  "+261",
  "+262",
  "+263",
  "+264",
  "+265",
  "+266",
  "+267",
  "+268",
  "+269",
  "+290",
  "+291",
  "+297",
  "+298",
  "+299",
  "+350",
  "+351",
  "+352",
  "+353",
  "+354",
  "+355",
  "+356",
  "+357",
  "+358",
  "+359",
  "+370",
  "+371",
  "+372",
  "+373",
  "+374",
  "+375",
  "+376",
  "+377",
  "+378",
  "+379",
  "+380",
  "+381",
  "+382",
  "+383",
  "+385",
  "+386",
  "+387",
  "+389",
  "+420",
  "+421",
  "+423",
  "+500",
  "+501",
  "+502",
  "+503",
  "+504",
  "+505",
  "+506",
  "+507",
  "+508",
  "+509",
  "+590",
  "+591",
  "+592",
  "+593",
  "+594",
  "+595",
  "+596",
  "+597",
  "+598",
  "+599",
  "+670",
  "+672",
  "+673",
  "+674",
  "+675",
  "+676",
  "+677",
  "+678",
  "+679",
  "+680",
  "+681",
  "+682",
  "+683",
  "+685",
  "+686",
  "+687",
  "+688",
  "+689",
  "+690",
  "+691",
  "+692",
  "+850",
  "+852",
  "+853",
  "+855",
  "+856",
  "+880",
  "+886",
  "+960",
  "+961",
  "+962",
  "+963",
  "+964",
  "+965",
  "+966",
  "+967",
  "+968",
  "+970",
  "+971",
  "+972",
  "+973",
  "+974",
  "+975",
  "+976",
  "+977",
  "+992",
  "+993",
  "+994",
  "+995",
  "+996",
  "+998",
]

export const COUNTRIES = [
  "Select one",
  "United States",
  "United Kingdom",
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belgium",
  "Belize",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Island",
  "Central African Republic",
  "Chile",
  "China",
  "Colombia",
  "Congo",
  "Costa Rica",
  "Cote D'ivoire",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guyana",
  "Haiti",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Korea",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Sweden",
  "Switzerland",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
]
export const ROLES = [
  "Select one",
  "Accountant / Controller",
  "Administrative / Assistant",
  "Analyst",
  "Application Developer",
  "Application Owner",
  "Back Office",
  "Broker",
  "Business Development / Sales",
  "Business Manager",
  "Capital Markets",
  "Cash Manager",
  "Chief Compliance Officer",
  "Chief Data Officer",
  "Chief Diversity Officer",
  "Chief Executive Officer",
  "Chief Financial Officer",
  "Chief Information Officer",
  "Chief Investment Officer",
  "Chief of Staff",
  "Chief Operating Officer",
  "Chief Risk Officer",
  "Chief Sustainability Officer",
  "Chief Technology Officer",
  "Client Services",
  "Collateral Management",
  "Compliance",
  "Consultant",
  "Control Owner",
  "Corporate Access",
  "Corporate Communications",
  "Corporate Development",
  "Corporate Finance",
  "Desk Head",
  "Development / Fundraiser",
  "Economist",
  "Engineer",
  "Enterprise Architect",
  "Executive Officer",
  "Faculty",
  "Financial Advisor",
  "Global Head",
  "Government Affairs",
  "Government Contracting",
  "Government Official",
  "Head of Digital",
  "Insurance Underwriter",
  "Intern",
  "Investment Banker",
  "Investor Relations",
  "Lawyer",
  "Loan Officer",
  "Market Data / Technology",
  "Market Maker",
  "Marketing",
  "Media",
  "Middle Office",
  "News Editor",
  "Originator",
  "Portfolio Manager",
  "Prime Broker",
  "Private Banker",
  "Private Equity",
  "Procurement",
  "Product Control",
  "Product Manager",
  "Professor",
  "Project Manager",
  "Proprietary Trader",
  "Quant",
  "Recruiter",
  "Regional Head",
  "Registered Investment Advisor",
  "Regulatory Reporting",
  "Research Admin",
  "Research Sales",
  "Risk Manager",
  "Sales Assistant / Trading Assistant",
  "Sales Support",
  "Sales Trader",
  "Salesperson",
  "Securities Lending",
  "Settlements",
  "Strategist",
  "Structurer",
  "Student",
  "Syndicator",
  "System Administrator",
  "Technical Support",
  "Technology",
  "Trade Support",
  "Trader",
  "Treasurer",
  "Venture Capitalist",
  "Not Applicable",
]

export const COMPANY_TYPES = [
  "Select one",
  "Asset Management Firm",
  "Broker Dealer",
  "Corporation (Non-Financial)",
  "Commercial Bank",
  "Government Agency",
  "Family Office",
  "Financial Technology Firm",
  "Hedge Fund",
  "Investment Advisory",
  "Investment Bank",
  "Insurance Company",
  "Mutual Fund",
  "Pension Fund",
  "Private Equity / Venture Capital",
  "Private Investor",
  "Proprietary Trading Firm",
  "RIA / Wealth Management",
  "REIT (Real Estate Investment Trust)",
  "Research Firm",
  "Other",
]